module.exports = __webpack_public_path__ + "media/images/official/bnr_event_sp-231bd33b73697f14ef1caaacb8f21e0d.jpg";